export const truncateText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) {
        return text; // nothing to truncate
    } else {
        return text.slice(0, maxLength) + "...";
    }
}
